import { render, staticRenderFns } from "./examinationLayout.vue?vue&type=template&id=778bcb5b&scoped=true"
import script from "./examinationLayout.vue?vue&type=script&lang=js"
export * from "./examinationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778bcb5b",
  null
  
)

export default component.exports